import {
  customShadowlessElement,
  type CorrectComponentType,
  correctElementType,
} from "@brytdesigns/web-component-core/utils";
import { onMount, onCleanup } from "solid-js";

type Props = {
  windowName: string;
  windowWidth: number;
  windowHeight: number;
};

const Component: CorrectComponentType<Props> = (props, { element }) => {
  if (!element.querySelector("a")) {
    return console.error("The component must have a <a> tag");
  }
  const controller = new AbortController();

  onMount(() => {
    const anchor = element.querySelector<HTMLAnchorElement>("a");
    anchor?.setAttribute("rel", "noopener noreferrer");
    anchor?.setAttribute("target", "_blank");
  });

  element.addEventListener(
    "click",
    async (event) => {
      event.preventDefault();
      const anchor = element.querySelector<HTMLAnchorElement>("a");
      if (!anchor) return;
      const href = anchor.getAttribute("href");
      if (!href) return;
      window.open(
        href,
        props.windowName,
        `width=${props.windowWidth},height=${props.windowHeight}`,
      );
    },
    {
      signal: controller.signal,
    },
  );

  onCleanup(() => {
    controller.abort();
  });
};

customShadowlessElement(
  "open-link-in-window-action",
  {
    windowName: "_blank",
    windowWidth: 800,
    windowHeight: 600,
  },
  correctElementType(Component),
);
